export default __webpack_public_path__ + "static/media/logo.14c19f92.png";